export const GDPR_VERSION = "2026-10-v1";

const Sec = ({ t, children }) => (<><h4>{t}</h4>{children}</>);

export default function BFGdprNotice({ cfg }) {
  const op = cfg.op_name || "Beauty Trends";
  const ids = [cfg.op_cui && `CUI ${cfg.op_cui}`, cfg.op_address, cfg.op_email && `e-mail ${cfg.op_email}`].filter(Boolean).join(", ");
  return (
    <div className="bf-gdpr-text" data-testid="bf-gdpr-notice">
      <h3>Notă de informare privind prelucrarea datelor cu caracter personal</h3>
      <p>Conform Regulamentului (UE) 2016/679 (GDPR) și Legii nr. 190/2018. Versiunea {GDPR_VERSION}.</p>
      <Sec t="1. Cine prelucrează datele">
        <p><b>{op}</b>{ids ? ` (${ids})` : ""}, în calitate de operator, împreună cu agenții de vânzări care lucrează pentru noi.</p>
      </Sec>
      <Sec t="2. Ce date colectăm">
        <p>Numele salonului, numele administratorului, CUI-ul firmei, adresa de livrare, adresa de e-mail și numărul de telefon. Mai colectăm produsele alese, data și ora acordului, adresa IP și tipul de browser, ca dovadă a acordului.</p>
      </Sec>
      <Sec t="3. De ce și pe ce temei">
        <ul>
          <li>Ca să preluăm, să confirmăm, să facturăm și să livrăm comanda: demersuri înainte de încheierea contractului și executarea lui (art. 6 alin. 1 lit. b GDPR).</li>
          <li>Pentru obligațiile legale fiscale și contabile (art. 6 alin. 1 lit. c).</li>
          <li>Ca să prevenim abuzurile și să măsurăm campania, adică statistici despre agenți și comenzi (interes legitim, art. 6 alin. 1 lit. f).</li>
          <li>Pentru oferte și noutăți viitoare, doar dacă bifezi separat (consimțământ, art. 6 alin. 1 lit. a). Îl poți retrage oricând.</li>
        </ul>
      </Sec>
      <Sec t="4. Cui transmitem datele">
        <p>Agentului de vânzări care te deservește, firmelor de curierat, contabilității și furnizorilor IT de găzduire și e-mail, toți obligați la confidențialitate. Dacă alegi să trimiți comanda pe WhatsApp, mesajul este transmis prin WhatsApp (Meta), care poate transfera date în afara UE pe baza clauzelor contractuale standard. Nu vindem datele tale.</p>
      </Sec>
      <Sec t="5. Cât timp le păstrăm">
        <p>Datele din comenzi și facturi: 10 ani, conform Legii contabilității nr. 82/1991. Datele de contact: cel mult 3 ani de la ultima interacțiune. Datele pentru marketing: până îți retragi acordul.</p>
      </Sec>
      <Sec t="6. Drepturile tale">
        <p>Ai dreptul să ceri acces la date, rectificarea sau ștergerea lor, restricționarea prelucrării, portabilitatea datelor, să te opui prelucrării și să îți retragi consimțământul, fără să fie afectată prelucrarea făcută până atunci. Cererile le trimiți {cfg.op_email ? `la ${cfg.op_email}` : "operatorului"} și îți răspundem în cel mult o lună. Poți depune plângere la ANSPDCP (B-dul G-ral Gheorghe Magheru 28-30, București, www.dataprotection.ro).</p>
      </Sec>
      <Sec t="7. Alte informații">
        <p>Datele sunt necesare ca să poți plasa comenzi B2B în campanie. Fără ele, comanda nu poate fi preluată. Nu luăm decizii automate cu efecte juridice asupra ta.</p>
      </Sec>
    </div>
  );
}
